import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.19971 5.15978C7.38761 5.36213 7.37589 5.6785 7.17354 5.8664L5.23478 7.66667L7.17354 9.46694C7.37589 9.65484 7.38761 9.97121 7.19971 10.1736C7.01181 10.3759 6.69544 10.3876 6.49309 10.1997L4.15975 8.03307C4.05787 7.93846 3.99998 7.8057 3.99998 7.66667C3.99998 7.52763 4.05787 7.39488 4.15975 7.30027L6.49309 5.13361C6.69544 4.9457 7.01181 4.95742 7.19971 5.15978Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8664 5.15978C11.0543 5.36213 11.0426 5.6785 10.8402 5.8664L8.90147 7.66667L10.8402 9.46694C11.0426 9.65484 11.0543 9.97121 10.8664 10.1736C10.6785 10.3759 10.3621 10.3876 10.1598 10.1997L7.82644 8.03307C7.72456 7.93846 7.66666 7.8057 7.66666 7.66667C7.66666 7.52763 7.72456 7.39488 7.82644 7.30027L10.1598 5.13361C10.3621 4.9457 10.6785 4.95742 10.8664 5.15978Z"
      fill="currentColor"
    />
  </SvgIcon>
));
